import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TreeSelectModule } from 'primeng/treeselect';
import { Category } from '../../../../import/category.type';
import { Shop } from '../../../../shop/types/shop.type';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProductService } from '../../../service/product.service';
import { UserService } from '../../../../user/services/user.service';
import { ShopService } from '../../../../shop/service/shop.service';

@Component({
  selector: 'app-edit-attribute-typology-seller',
  templateUrl: './edit-attribute-typology-seller.component.html',
  standalone: true,
  imports: [TranslateModule, ProgressSpinnerModule, TreeSelectModule, ButtonModule, FormsModule],
  styleUrls: ['./edit-attribute-typology-seller.component.scss']
})
export class EditAttributeTypologySellerComponent implements OnInit {
  showSpinner = false;
  categories: Category[];
  attribute;
  currentProduct;
  shop: Shop;
  selectedCategory: any;
  constructor(public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private readonly userService: UserService,
        private readonly shopService: ShopService,
        private readonly productService: ProductService) { }

  ngOnInit() {
    this.attribute = this.config?.data['attribute'];
    this.shop = this.shopService.getSelectedShop();
    this.currentProduct = this.config?.data['currentProduct'];
    this.categories = this.config?.data['categories'];
    this.selectedCategory = this.config?.data['selectedCategory'];
    

  }
  updateAttributeTypology(){
    this.showSpinner = true;
    const data = {
      productId: this.currentProduct.productId,
      shopCode: this.shop.shopCode,
      shopName: this.shop.shopName,
      eans: this.currentProduct.ean,
      sku: this.currentProduct.sku,
      user: this.userService.getUser().email,
      attributesModifications: [{
        localized: this.attribute.localized ,
        project: this.attribute.locale,
        attributeCode: this.attribute.attributeCode,
        attributeValue: this.selectedCategory.categoryBreadcrumbLoc,
        attributeCodeValue: this.selectedCategory.categoryId
      }],
      categoryBreadCrumb: this.selectedCategory.categoryBreadcrumbLoc,
      isMedia: this.attribute.attributeType === 'MEDIA'
    };
      this.productService.updateProduct(data).subscribe({
        next: () => {
          this.showSpinner = false;
          this.closeDialog('success');
        },
        error: () => {
          this.showSpinner = false;
          this.closeDialog('error');
        },
      });
    
  }

  closeDialog(msg = null): void {
    this.ref.close(msg);
  }
}
